import axios from "@/plugins/axios";

let url = "/api/v1/easyleg/reviews2";

export const reviews2 = {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
}